import { Component, Input } from '@angular/core';
import { StatusIndicator } from './sidebar.models';

@Component({
  selector: 'ui-sidebar-item-status-indicator',
  template: `
    <div
      class="w-1.5 h-1.5 rounded-full"
      [class]="statusClassMap[status || 'default']"
    ></div>
  `,
  styles: []
})
export class StatusIndicatorComponent {
  @Input() status: StatusIndicator | null = null;

  // Hash map to associate status values with CSS classes
  statusClassMap: { [key in StatusIndicator | 'default']: string } = {
    available: 'bg-green',
    unavailable: 'bg-gray-400',
    default: 'bg-gray-200',
  };
}
